const getParentWindow = () => {
  try {
    // eslint-disable-next-line no-restricted-properties
    return window.parent;
  } catch {
    // IFrame parent document is not accessible when cross-origin.
    return null;
  }
};

export default getParentWindow;
